module.exports = __webpack_public_path__ + "static/media/pda4.25318fdd.png";